import BaseAPI from './base'

class FirmwareCategoryAPI extends BaseAPI {
  getSystemFirmwareCategories = (query) =>
    this.client.get(`pers/firmware-categories?${query}`, {
      baseURL: this.fleetURL
    })
}

export default new FirmwareCategoryAPI()
